/**
 * Services Tabs in Homepage
 *
 * @module
 */

import { $$ } from '../../utilities/QuerySelectors.js';

export class ServicesTabs {
    /**
     * Interactivity for the Services Tabs component.
     *
     * @param {Element} container
     */
    constructor(container) {
        this.container = container;
        this.$ = (sel) => container.querySelector(sel);
    }

    /**
     * Initialize the Services Tabs tab switching.
     *
     * @return {void}
     */
    init() {
        /** @type {HTMLElement[]} */
        // @ts-ignore: cannot easily cast to HTMLElement
        this.tabs = $$('.tabs__tab', this.container);
        this.headerUl = this.$('.tabs__header ul');

        if (this.tabs.length === 0) {
            return;
        }

        this.createToggleButtons();
        this.enableTabTogglers();
        this.toggleTabByTitle(this.tabs[0].dataset.tabTitle);
        this.container.classList.add('init');
        setTimeout(() => this.container.classList.add('fouc-ready'), 100);
    }

    /**
     * Create tab toggle button
     *
     * @private
     * @param {HTMLElement} tab
     * @return {string}
     */
    createToggleButton(tab) {
        return `<button
            class="tabs__tab-toggler no-btn-style"
            data-tab-title="${tab.dataset.tabTitle}"
            style="border-color: ${tab.dataset.tabColor};"
        >
            ${tab.dataset.tabTitle}
        </button>`;
    }

    /**
     * Create tab buttons
     *
     * @private
     * @return {void}
     */
    createToggleButtons() {
        const html = this.tabs.map((t) => `<li>${this.createToggleButton(t)}</li>`).join('');
        this.headerUl.insertAdjacentHTML('beforeend', html);
        /** @type {HTMLElement[]} */
        // @ts-ignore: cannot easily cast to HTMLElement
        this.toggleButtons = $$('.tabs__tab-toggler', this.container);
    }

    /**
     * Switch tab.
     *
     * @param {string} tabTitle
     * @return {void}
     */
    toggleTabByTitle(tabTitle) {
        this.tabs.forEach((tab) => {
            tab.classList[tab.dataset.tabTitle === tabTitle ? 'add' : 'remove']('selected');
        });
        this.toggleButtons.forEach((btn) => {
            btn.classList[btn.dataset.tabTitle === tabTitle ? 'add' : 'remove']('selected');
        });
    }

    /**
     * Initialize tab switch on button click.
     *
     * @private
     * @return {void}
     */
    enableTabTogglers() {
        this.headerUl.addEventListener('click', (e) => {
            if (e.target.nodeName === 'BUTTON') {
                this.toggleTabByTitle(e.target.dataset.tabTitle);
            }
        });
    }
}
